<template>
    <div class="editor-color-picker">
        <label :title="title">
            <i :class="icon"></i>
            <input type="color" :value="modelValue" @input="$emit('update:modelValue', ($event.target as any).value)" />
            <span v-if="showColorCode">{{ modelValue }}</span>
        </label>
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        title: string;
        icon: string;
        modelValue: string;
        showColorCode: boolean;
    }>();

    defineEmits(["update:modelValue"]);
</script>

<style scoped lang="scss">
    .editor-color-picker {
        label {
            align-items: center;
            gap: 0.3rem;
            padding: 0.3rem 0.5rem;
            border: 1px solid #ccc;
            background: white;
            border-radius: 0.3rem;
            cursor: pointer;
            margin-bottom: 0;

            input[type="color"] {
                border: none;
                background: none;
                padding: 0;
                width: 1.5rem;
                height: 1.5rem;
                cursor: pointer;
                vertical-align: middle;
            }

            i {
                pointer-events: none;
                vertical-align: middle;
            }

            span {
                vertical-align: middle;
            }
        }
    }
</style>
